export const AnimalGroupVeterinarians = [
  {
    id: 'ANIMALCARE',
    name: 'Animal Care, Dierenartsen',
    address: 'Goede Reede 3',
    postcode: '3845 MD',
    city: 'Harderwijk',
    country: 'NL',
  },
  {
    id: 'ARTE',
    name: 'DAP Arts & Dier (Emmen)',
    address: 'Noordbargerstraat 11 a',
    postcode: '7811 KE',
    city: 'Emmen',
    country: 'NL',
  },
  {
    id: 'BOSL',
    name: 'DAP Boschhoven (Spoorenberg)',
    address: 'Boschhoven  54',
    postcode: '5595 AR',
    city: 'Leende',
    country: 'NL',
  },
  {
    id: 'DACH',
    name: 'Poultry Vets Noord',
    address: 'Spoorstraat 88',
    postcode: '7261 AG',
    city: 'Ruurlo',
    country: 'NL',
  },
  {
    id: 'DACSIJR',
    name: 'DAC Van Vecht tot Venen  (Staphorst)',
    address: 'Achthoevenweg 10',
    postcode: '7951 SK',
    city: 'Staphorst',
    country: 'NL',
  },
  {
    id: 'DAHD',
    name: 'AdVee dierenartsen (HeeswykDinther)',
    address: 'Laag Beugt 2 B',
    postcode: '5473 KB',
    city: 'Heeswijk-Dinther',
    country: 'NL',
  },
  {
    id: 'DAHH',
    name: 'DAP Haaksbergen',
    address: 'Tolstraat 12',
    postcode: '7482 DB',
    city: 'Haaksbergen',
    country: 'NL',
  },
  {
    id: 'DAOG',
    name: 'DAP Oost Groningen',
    address: 'Industrieweg 23',
    postcode: '9672 AP',
    city: 'Winschoten',
    country: 'NL',
  },
  {
    id: 'DAOT',
    name: 'DAP Oude Tonge',
    address: 'Langeweg 6',
    postcode: '3255 LJ',
    city: 'Oude Tonge',
    country: 'NL',
  },
  {
    id: 'DAPE',
    name: 'DAP Enschede',
    address: 'Brinkstraat 234',
    postcode: '7541 AV',
    city: 'Enschede',
    country: 'NL',
  },
  {
    id: 'DAPP',
    name: 'DAP Putten',
    address: '',
    postcode: '�',
    city: 'Putten',
    country: 'NL',
  },
  {
    id: 'DAVZ',
    name: 'DAP AviVet B.V.',
    address: 'Egelinglaan 8B',
    postcode: '3705 TC',
    city: 'Zeist',
    country: 'NL',
  },
  {
    id: 'DBERG',
    name: 'DAP Bergen-Gennep-Goch-Velden,    = MNB',
    address: 'Siebengewaldseweg 133',
    postcode: '5854 PB',
    city: 'Bergen (Lb)',
    country: 'NL',
  },
  {
    id: 'DBORN',
    name: 'DAP Bornerbroek',
    address: 'Schapendrift 7 a',
    postcode: '7627 RA',
    city: 'Bornerbroek',
    country: 'NL',
  },
  {
    id: 'DBVE',
    name: 'DGC Boven-Veluwe',
    address: 'Rondweg 78',
    postcode: '8091 XK',
    city: 'Wezep',
    country: 'NL',
  },
  {
    id: 'DBW',
    name: 'DAP DC Bornerbroek-Wierden',
    address: 'Eikenlaan 9',
    postcode: '7642 GA',
    city: 'Wierden',
    country: 'NL',
  },
  {
    id: 'DCA',
    name: 'DAP DCA',
    address: 'Prins Bernhardstraat 56',
    postcode: '5721 GC',
    city: 'Asten',
    country: 'NL',
  },
  {
    id: 'DDEV',
    name: 'Dierenarts Deventer eo',
    address: 'Leonard Springerlaan  85',
    postcode: '7425 BT',
    city: 'Deventer',
    country: 'NL',
  },
  {
    id: 'DDHA',
    name: 'Dierenkliniek Den Ham, Grover Driesland',
    address: 'Daarleseweg 35 a',
    postcode: '7683 RC',
    city: 'Den Ham (Ov)',
    country: 'NL',
  },
  {
    id: 'DDKE',
    name: 'DAP De Kempen',
    address: 'Mr. Pankenstraat 9',
    postcode: '5571 CP',
    city: 'Bergeyk',
    country: 'NL',
  },
  {
    id: 'DEGR',
    name: 'DAP De Grensstreek Bladel',
    address: 'Ambachtsweg 5x',
    postcode: '5531 AC',
    city: 'Bladel',
    country: 'NL',
  },
  {
    id: 'DEHE',
    name: 'Poultry Vets',
    address: 'Hoogstraat 7',
    postcode: '6011 RX',
    city: 'Ell',
    country: 'NL',
  },
  {
    id: 'DEIB',
    name: 'DAP Eibergen',
    address: 'Hondevoort 11',
    postcode: '7152 BA',
    city: 'Eibergen',
    country: 'NL',
  },
  {
    id: 'DEMD',
    name: 'DAP Demetris DierGezondheid BV',
    address: 'Impact 14',
    postcode: '6921 RZ',
    city: 'Duiven',
    country: 'NL',
  },
  {
    id: 'DGCP',
    name: 'DAP Markgraven',
    address: 'Almeloseweg 169',
    postcode: '7615 NA',
    city: 'Harbrinkhoek',
    country: 'NL',
  },
  {
    id: 'DGEM',
    name: 'DAC ZuidOost  (Gemert)',
    address: 'Griffier Corstensstraat 6',
    postcode: '5421 HP',
    city: 'Gemert',
    country: 'NL',
  },
  {
    id: 'DGOO',
    name: 'DAP Goor',
    address: 'Spechthorstweg 2',
    postcode: '7471 GH',
    city: 'Goor',
    country: 'NL',
  },
  {
    id: 'DHAGMOLEN',
    name: 'Hagmolen, Dierenkliniek De',
    address: 'Deldenerdijk 80',
    postcode: '7554 RD',
    city: 'Hengelo (Beckum)',
    country: 'NL',
  },
  {
    id: 'DHEL',
    name: 'Dierenkliniek Hellendoorn Nijverdal',
    address: 'Ommerweg 54',
    postcode: '7447 RG',
    city: 'Hellendoorn',
    country: 'NL',
  },
  {
    id: 'DHEN',
    name: 'Dierenkliniek Hellendoorn Nijverdal',
    address: 'Koersendijk 16',
    postcode: '7443 PR',
    city: 'Nijverdal',
    country: 'NL',
  },
  {
    id: 'DHNO',
    name: 'DAP Holland Noord',
    address: 'Koningin Wilhelminaweg 25',
    postcode: '1774 AA',
    city: 'Slootdorp',
    country: 'NL',
  },
  {
    id: 'DHOL',
    name: 'DAC Holten',
    address: 'Dorpsstraat 24 c',
    postcode: '7451 BV',
    city: 'Holten',
    country: 'NL',
  },
  {
    id: 'DIERNARTS',
    name: 'Dier-N-Artsen',
    address: 'Hoogstraat 98 A',
    postcode: '4909 AV',
    city: 'Oosteind',
    country: 'NL',
  },
  {
    id: 'DIJSS',
    name: 'AdVee dierenartsen (Ysselsteyn)',
    address: 'Ringweg 25',
    postcode: '5813 BP',
    city: 'Ysselsteyn (Lb)',
    country: 'NL',
  },
  {
    id: 'DLEK',
    name: 'DAP Lekstreek',
    address: 'Ambachtsweg 2',
    postcode: '3381 LN',
    city: 'Giessenburg',
    country: 'NL',
  },
  {
    id: 'DLIN',
    name: 'DAP Lintjeshof',
    address: 'Pannenweg 200',
    postcode: '6031 RK',
    city: 'Nederweert',
    country: 'NL',
  },
  {
    id: 'DMAR',
    name: 'DAP Markelo De Vijf Heuvels',
    address: 'Spelleweg 12',
    postcode: '7475 GV',
    city: 'Markelo',
    country: 'NL',
  },
  {
    id: 'DMB',
    name: 'Poultry Vets Zuid',
    address: 'Beekseweg 11 a',
    postcode: '5087 KA',
    city: 'Diessen',
    country: 'NL',
  },
  {
    id: 'DMSA',
    name: 'DGC Midden Salland',
    address: 'Burg Kerssemakersstraat 48',
    postcode: '8101 AP',
    city: 'Raalte',
    country: 'NL',
  },
  {
    id: 'DNNE',
    name: 'Ommelander Dierenklinieken Veendam (Nrd Ned)',
    address: 'Aquapark 11',
    postcode: '9641 PJ',
    city: 'Veendam',
    country: 'NL',
  },
  {
    id: 'DNOL',
    name: 'DAP Noord & Oost (Leek)',
    address: 'Lorentzpark 24',
    postcode: '9351 VJ',
    city: 'Leek',
    country: 'NL',
  },
  {
    id: 'DNOS',
    name: 'Pluimveepraktijk Noord & Oost (Slagharen)',
    address: 'Herenstraat 79',
    postcode: '7776 AM',
    city: 'Slagharen',
    country: 'NL',
  },
  {
    id: 'DNWF',
    name: 'DAP N.W.Friesland',
    address: 'Het Want 4',
    postcode: '8802 PV',
    city: 'Franeker',
    country: 'NL',
  },
  {
    id: 'DODK',
    name: 'DAP Arts & Dier (Klijndijk)',
    address: 'Hoofdweg 26 a',
    postcode: '7871 TC',
    city: 'Klijndijk',
    country: 'NL',
  },
  {
    id: 'DODN',
    name: 'DAP Oost Drenthe (Nieuw Buinen)',
    address: 'Zuiderdiep 359 a',
    postcode: '9521 AK',
    city: 'Nieuw-Buinen',
    country: 'NL',
  },
  {
    id: 'DOLD',
    name: 'DAP Oldenzaal',
    address: 'Hengelosestraat 58',
    postcode: '7572 BR',
    city: 'Oldenzaal',
    country: 'NL',
  },
  {
    id: 'DOUD',
    name: 'DAP Oudewater',
    address: 'Pastoorsakker 53',
    postcode: '3425 ET',
    city: 'Snelrewaard',
    country: 'NL',
  },
  {
    id: 'DOWI',
    name: 'DAP Olst / Wijhe',
    address: 'Jan Hooglandstraat 4',
    postcode: '8121 BX',
    city: 'Olst',
    country: 'NL',
  },
  {
    id: 'DPHC',
    name: 'DAP Poultry Health Care B.V. (PHC)',
    address: 'Postbus 173',
    postcode: '7940 AD',
    city: 'Meppel',
    country: 'NL',
  },
  {
    id: 'DPLA',
    name: 'Avecur b.v. (Hardenberg)',
    address: 'Maalstoel 6',
    postcode: '7773 NN',
    city: 'Hardenberg',
    country: 'NL',
  },
  {
    id: 'DPOUL',
    name: 'Poulvet, Dierenartsenpraktijk',
    address: 'Neerloopweg 4 B',
    postcode: '4814 RS',
    city: 'Breda',
    country: 'NL',
  },
  {
    id: 'DSNE',
    name: 'DAP Snelrewaard',
    address: '� 0',
    postcode: '�',
    city: 'Snelrewaard',
    country: 'NL',
  },
  {
    id: 'DSTO',
    name: 'DAP Sint Oedenrode',
    address: 'Kortestraat 1',
    postcode: '5491 SZ',
    city: 'Sint Oedenrode',
    country: 'NL',
  },
  {
    id: 'DTMA',
    name: 'DAP Tussen Mark en Amer (Made)',
    address: 'Watertorenstraat 9',
    postcode: '4927 RG',
    city: 'Hooge Zwaluwe',
    country: 'NL',
  },
  {
    id: 'DTUB',
    name: 'DAP Tubbergen',
    address: 'Oldenzaalseweg 21',
    postcode: '7651 KA',
    city: 'Tubbergen',
    country: 'NL',
  },
  {
    id: 'DTWENTE',
    name: 'Diergeneeskundig Centrum Twente',
    address: 'Almelosestraat 46',
    postcode: '7642 GP',
    city: 'Wierden',
    country: 'NL',
  },
  {
    id: 'DVCS',
    name: 'DAP Veterinair Centrum Someren',
    address: 'Slievenstraat  16',
    postcode: '5711 PK',
    city: 'Someren',
    country: 'NL',
  },
  {
    id: 'DVETMED',
    name: 'VETMED',
    address: 'Lorentzlaan 33',
    postcode: '8024 XJ',
    city: 'Zwolle',
    country: 'NL',
  },
  {
    id: 'DVOO',
    name: 'DAP Voorthuizen VUG',
    address: 'Evertsenlaan 18',
    postcode: '3781 TB',
    city: 'Voorthuizen',
    country: 'NL',
  },
  {
    id: 'DVPH',
    name: 'DMC Voorne-Putten (Hellevoetsluis)',
    address: 'Martin Luther Kinglaan  1',
    postcode: '3223 GG',
    city: 'Hellevoetsluis',
    country: 'NL',
  },
  {
    id: 'DWIN',
    name: 'DAP Van Duin tot Dijk Winkel',
    address: 'Corsolaan 13',
    postcode: '1731 WE',
    city: 'Winkel',
    country: 'NL',
  },
  {
    id: 'DWIT',
    name: 'DAP De Dijken Witmarsum',
    address: 'De Spinnekop 6',
    postcode: '8748 BG',
    city: 'Witmarsum',
    country: 'NL',
  },
  {
    id: 'DWNE',
    name: 'DAP West-Nederland',
    address: 'Goudbloemsedijk 10',
    postcode: '4741  SN',
    city: 'Hoeven',
    country: 'NL',
  },
  {
    id: 'DZNE',
    name: 'Pluimveepraktijk Zuid-Nederland',
    address: 'Lieropsedijk 11',
    postcode: '5711 PN',
    city: 'Someren',
    country: 'NL',
  },
  {
    id: 'DZOD',
    name: 'DAP Z.O. Drenthe',
    address: 'Looweg 84',
    postcode: '7741 EE',
    city: 'Coevorden',
    country: 'NL',
  },
  {
    id: 'DZUI',
    name: 'DAP Zuidhorn',
    address: 'Wilhelminalaan 7',
    postcode: '9801 BC',
    city: 'Zuidhorn',
    country: 'NL',
  },
  {
    id: 'EENA',
    name: 'DAP De Eenhoorn, plv naar DEHE',
    address: 'Ommelsveld 25',
    postcode: '5721 VT',
    city: 'Asten',
    country: 'NL',
  },
  {
    id: 'EMME',
    name: 'DAP Emmeloord',
    address: 'Coeshoeck 2',
    postcode: '8303 XG',
    city: 'Emmeloord',
    country: 'NL',
  },
  {
    id: 'FACU',
    name: 'DAP Faculteit der Diergeneeskunde',
    address: 'Yalelaan 7',
    postcode: '3584 CL',
    city: 'Utrecht',
    country: 'NL',
  },
  {
    id: 'FARM',
    name: 'Dierenkliniek Staphorst',
    address: 'Wethouder Timmermanstraat 15 A',
    postcode: '7951 VH',
    city: 'Staphorst',
    country: 'NL',
  },
  {
    id: 'GVPE',
    name: 'DAP Gezondheidscentrum v. Pluimvee',
    address: 'James Cookstraat 10',
    postcode: '7825 AN',
    city: 'Emmen',
    country: 'NL',
  },
  {
    id: 'KONINGSLUS',
    name: 'Verstraten Medico Koningslust',
    address: 'Sevenumsedijk 18',
    postcode: '5984 PC',
    city: 'Koningslust',
    country: 'NL',
  },
  {
    id: 'KUNZ',
    name: 'Avecur b.v.    (Balkbrug), alleen DPLA',
    address: 'De Maat 31 a',
    postcode: '7707 RN',
    city: 'Balkbrug',
    country: 'NL',
  },
  {
    id: 'LANW',
    name: 'DAP De Langstraat',
    address: 'Eerste Zeine 112',
    postcode: '5144 AM',
    city: 'Waalwijk',
    country: 'NL',
  },
  {
    id: 'MNB',
    name: 'DAP Maas en Niers',
    address: 'Jeroen Boschstraat 26',
    postcode: '5854 CZ',
    city: 'Bergen',
    country: 'NL',
  },
  {
    id: 'ODR',
    name: 'Gezondheidscentrum voor Pluimvee (GvP)',
    address: 'Atlantis 39',
    postcode: '7821 AX',
    city: 'Emmen',
    country: 'NL',
  },
  {
    id: 'PEELARTSNL',
    name: 'Peelarts (NL)',
    address: 'Patrijs 34',
    postcode: '7951 VH',
    city: 'Staphorst',
    country: 'NL',
  },
  {
    id: 'PEUH',
    name: 'DAP DGC De Peuvers Esch',
    address: 'Almeloseweg  169',
    postcode: '7615 NA',
    city: 'Harbrinkhoek',
    country: 'NL',
  },
  {
    id: 'PZNL',
    name: 'Pluimveepraktijk Zuid',
    address: 'Streeksteeg 10',
    postcode: '6003',
    city: 'PN Weert',
    country: 'NL',
  },
  {
    id: 'ROE',
    name: 'DAP Romme',
    address: 'Zwaluw 6',
    postcode: '4872 SL',
    city: 'Etten Leur',
    country: 'NL',
  },
  {
    id: 'WIER',
    name: 'DAP Van Duin tot Dijk',
    address: 'Corsolaan 13',
    postcode: '1731 WE',
    city: 'Winkel',
    country: 'NL',
  },
];
